module.exports = __webpack_public_path__ + "img/icon_inverted.d5dc076c.png";